export default __webpack_public_path__ + "static/media/timer_background_xl1.52b4386f.jpg";